<template>
  <div class="l-block__detail findKeyword">
    <TitleSub level="h3">
      <span class="title">対策キーワードを探す</span>
      <span class="description">
        2種類の方法から、流入を狙うキーワードを探しましょう。
      </span>
    </TitleSub>

    <div class="c-section--competitiveKeyword">
      <TitleSub level="h4">
        <span class="title">①軸キーワードを拡張する</span>
        <Tooltip size="sm" position="bottom">
          軸キーワードの決め方は
          <a
            href="https://support.searchwrite.jp/hc/ja/articles/4412416261391--%E9%96%A2%E9%80%A3%E3%82%AD%E3%83%BC%E3%83%AF%E3%83%BC%E3%83%89%E5%88%86%E6%9E%90-%E3%81%A7%E8%AA%BF%E6%9F%BB%E3%81%99%E3%82%8B%E3%82%AD%E3%83%BC%E3%83%AF%E3%83%BC%E3%83%89%E3%82%92%E6%B1%BA%E3%82%81%E3%81%9F%E3%81%84"
            class="l-side-logo__link c-link--blank"
            target="_blank"
          >
            こちら
          </a>
          の記事をご覧ください。
        </Tooltip>
      </TitleSub>
      <p class="c-section--description">
        軸となるキーワードが決まっている場合、その関連ワードから探すのがおすすめです。<br />
        「関連ワード分析」で軸キーワードを分析することで、キーワードを拡張できます。
      </p>

      <Button
        variant="main"
        :to="{
          name: 'competitiveKeyword'
        }"
        size="w400"
        fsize="f16"
        radius
      >
        「関連ワード分析」で軸キーワードを拡張する
      </Button>
    </div>
    <div class="c-section--competitiveSiteKeyword">
      <TitleSub level="h4">
        <span class="title">②競合サイトの獲得キーワードを調べる </span>
        <Tooltip size="sm" position="bottom">
          競合ドメインの見つけ方は
          <a
            href="https://support.searchwrite.jp/hc/ja/articles/4413249056143"
            class="l-side-logo__link c-link--blank"
            target="_blank"
          >
            こちら
          </a>
          の記事をご覧ください。
        </Tooltip>
      </TitleSub>
      <p class="c-section--description">
        ベンチマークしたい競合サイトがある場合、そのサイトの獲得ワードから探すのがおすすめです。<br />
        「競合キーワード分析」で競合ドメインを分析することで、キーワードを調査できます。
      </p>

      <Button
        variant="main"
        :to="{
          name: 'competitiveSiteKeyword'
        }"
        size="w400"
        fsize="f16"
        radius
      >
        「競合キーワード分析」で競合ドメインを調査する
      </Button>
    </div>
  </div>
</template>

<script>
import TitleSub from '@/components/TitleSub';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';

export default {
  components: {
    TitleSub,
    Button,
    Tooltip
  }
};
</script>
